import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'src/utils/axiosCatalog';
import axiosHeadOffice from 'src/utils/axiosWOBaseUrl';

export const getExchangeReasonCatalog = createAsyncThunk('/GetExchangeReasonCatalog', async () => {
  const response = await axios.get('/GetExchangeReasonCatalog');
  return response.data;
});

export const getExchangeReasonDetail = createAsyncThunk(
  '/getExchangeReasonDetailCatalog',
  async (id) => {
    const response = await axios.get(`/GetChangeReasonDetailCatalog/${id}`);
    return response.data;
  }
);

export const getReasonGroupList = createAsyncThunk(
  '/getReasonGroupList',
  async () => {
    const response = await axios.get('/GetReasonGroupList/');
    return response.data;
  }
);

export const getSAPList = createAsyncThunk(
  '/getSAPList',
  async () => {
    const response = await axios.get('/GetSAPList/');
    return response.data;
  }
);

export const getLanguageList = createAsyncThunk(
  '/getLanguageList',
  async () => {
    const response = await axiosHeadOffice.get('/Technician/GetLanguageList');
    return response.data;
  }
);


const exchangeReasonSlice = createSlice({
  name: 'exchangeReason',
  initialState: {
    selectedItemId: 0,
    loading: false,
    error: '',
    exchangeReasonTypes: [],
    exchangeReasonDescriptions: [],
    SelectedAppTranslationId: 0,
    IsChecked: true,
    SapList: [],
    SapId: '',
    MobileStatus: '',
    MobileStatusId: 0,
    MobileStatusList: [],
    response: ''
  },
  reducers: {
    changeSelectedAppTranslationId(state, action) {
      state.SelectedAppTranslationId = action.payload;
    },
    changeselectedItemId(state, action) {
      state.selectedItemId = action.payload;
    },
    resetDescriptions(state) {
      state.exchangeReasonDescriptions = [];
    },
    changeIsChecked(state, action) {
      state.IsChecked = action.payload;
    },
    changeSapId(state, action) {
      state.SapId = action.payload;
    },
    changeMobileStatus(state, action) {
      state.MobileStatus = action.payload;
      state.MobileStatusId = state.MobileStatusList.find((m) => m.Description === state.MobileStatus).ID;
    },
    changeMobileStatusId(state, action) {
      state.MobileStatusId = action.payload;
    },
  },
  extraReducers: {
    [getExchangeReasonCatalog.pending]: (state) => {
      state.loading = true;
    },
    [getExchangeReasonCatalog.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getExchangeReasonCatalog.fulfilled]: (state, action) => {
      state.exchangeReasonTypes = action.payload;
      state.loading = false;
    },
    [getExchangeReasonDetail.pending]: (state) => {
      state.loading = true;
    },
    [getExchangeReasonDetail.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getExchangeReasonDetail.fulfilled]: (state, action) => {
      state.exchangeReasonDescriptions = action.payload;
      state.loading = false;
    },
    [getLanguageList.pending]: (state) => {
      state.loading = true;
    },
    [getLanguageList.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getLanguageList.fulfilled]: (state, action) => {
      state.exchangeReasonDescriptions = action.payload;
      state.loading = false;
    },
    [getSAPList.pending]: (state) => {
      state.loading = true;
    },
    [getSAPList.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getSAPList.fulfilled]: (state, action) => {
      state.SapList = action.payload;
      state.loading = false;
    },
    [getReasonGroupList.pending]: (state) => {
      state.loading = true;
    },
    [getReasonGroupList.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading=false
    },
    [getReasonGroupList.fulfilled]: (state, action) => {
      state.MobileStatusList = action.payload;
      state.loading = false;
    },
  }
});

export const exchangeReasonActions = exchangeReasonSlice.actions;

export default exchangeReasonSlice;
